<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
<!--    <Title :title="route"></Title>-->

    <Setp :nodes="nodes" :audits="audits"></Setp>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px" shadow="never">
      <el-form label-position="left" label-width="150px">

        <el-divider content-position="left">申请人信息</el-divider>

        <el-form-item label="申请人" prop="">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>

        <el-form-item label="所属部门" prop="">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>

        <el-divider content-position="left">合同信息</el-divider>

        <el-form-item label="所属项目" prop="projectId">
          <el-input v-model="detail.projectName" readonly></el-input>
        </el-form-item>

        <el-form-item label="合同名" prop="contractName">
          <el-input v-model="detail.contractName" readonly></el-input>
        </el-form-item>

        <el-form-item label="合同类型" prop="contractType">
          <el-radio-group v-model="detail.contractType" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">销售合同</el-radio>
            <el-radio label="2">渠道合同</el-radio>
            <el-radio label="3">框架协议</el-radio>
            <el-radio label="4">采购合同</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="合同签署" prop="contractSign">
          <el-radio-group v-model="detail.contractSign" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">御码网控</el-radio>
            <el-radio label="2">中科安永</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="合同金额" prop="contractAmount">
          <el-input v-model="detail.contractAmount" maxlength="12" readonly></el-input>
        </el-form-item>

        <el-form-item v-for="(item, index) in detail.signCompany"
          :label="domainText[index] + '方'"
        >
          <el-input v-if="item.name" v-model="item.name" readonly></el-input>
          <el-input v-if="item.contact" v-model="item.contact" readonly></el-input>
          <el-input v-if="item.remark" v-model="item.remark" readonly></el-input>
        </el-form-item>

        <!--<el-form-item label="合同签署单位" prop="signCompany">-->
        <!--  <el-input v-model="detail.signCompany" readonly></el-input>-->
        <!--</el-form-item>-->

        <el-form-item label="合同签署时间" prop="contractSignTime">
          <el-date-picker
              readonly
              v-model="detail.contractSignTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="请选择合同签署时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="合同文件">
          <el-link type="primary" @click="download()">下载文件</el-link>
          <el-link style="margin-left: 8px" v-if="isPdf(detail.filePath)" type="primary" @click="viewPdf(detail.filePath)">预览</el-link>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit readonly
                    v-model="detail.remarks"></el-input>
        </el-form-item>

        <!--        <el-divider content-position="left">审核流程</el-divider>-->

        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>

        <div v-if="allowAudit==true">
          <el-divider content-position="left">我要审批</el-divider>

          <el-form-item label="审批意见" prop="remarks">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                      v-model="ruleForm.auditOpinion"></el-input>
          </el-form-item>

          <el-Form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-Form-item>
        </div>
      </el-form>

    </el-card>
    <el-dialog :visible.sync="showPdf" :append-to-body="true" top="0" custom-class="pdf-viewer">
      <div style="width:100%; height:100%;">
        <iframe id="myIframe" :src="pdfurl" width="100%" height="900px"></iframe>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Title from "../../Title";
import {requestApplyDetail, requestAudit, requestAuditShow} from "@/api";
import {minioServer, IsPdf} from "@/util";
import Setp from "../common/Setp";
import AuditList from "../common/AuditList";

export default {
  components: {AuditList, Setp, Title},
  name: "ContractDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showInfo: false,
      domainText: ['甲','乙','丙','丁','戊','己','庚','辛','壬','癸'],
      detail: {},
      audits: [],
      auditHistory: [],
      applyId: "",
      applyServiceId: "",
      applyType: "",
      ruleForm: {
        auditOpinion: "",
      },
      user: {},
      nodes: [],
      allowAudit: false,
      route: {
        name: '合同归档申请详情',
        path: ''
      },
      pdfurl: "",
      showPdf: false
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    download() {
      window.open(minioServer + this.detail.filePath)
    },
    getAuditShow() {
      requestAuditShow({
        applyId: this.applyId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            if (res.object == 1) {
              this.allowAudit = true
            }
            if (res.object == 2) {
              this.allowAudit = false
            }
          }
        }
      })
    },
    audit(isAgree) {

      this.allowAudit = false

      if (isAgree == 2 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "不同意"
      }
      requestAudit({
        isAgree: isAgree,
        applyId: this.applyId,
        applyType: this.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      }).then(res => {
        if (res.code == 200) {
          this.getAuditShow()
          this.getObject()
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail
            if (res.object.detail.contractType) {
              this.detail.contractType = res.object.detail.contractType + ""
            }
            this.detail.signCompany = JSON.parse(this.detail.signCompany)
            this.audits = res.object.audits
            this.user = res.object.user
            this.nodes = res.object.nodes
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    viewPdf(path) {
      this.showPdf = true
      this.pdfurl = "/pdfjs/web/viewer.html?file=" + minioServer + path
    },
    isPdf(fileName) {
      return IsPdf(fileName)
    }
  }
}
</script>

<style>


</style>